import { Input } from '@lib/components'
import type React from 'react'

import { GUEST_NAME_MAX } from '@/hooks'
import css from './styles.module.css'

interface Props {
  value: string
  onChange: (value: string) => void
}

/**
 * Where an anonymous visitor names themselves. Optional, though the field does
 * not say so: this sits on top of the comment box on a public share page, and
 * refusing the comment over a missing name would cost the project owner
 * feedback they want more. Left empty, the comment is stored with no name and
 * the API reports `guest_name: null` — the documented normal case, not a
 * failure.
 */
export const GuestName: React.FC<Props> = ({ value, onChange }) => (
  <div className={css.wrapper}>
    <Input
      type="normal"
      size="medium"
      placeholder="Your name"
      initialValue={value}
      maxLength={GUEST_NAME_MAX}
      onChange={onChange}
    />
  </div>
)
